import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select']
  static values = { reviewSort: Boolean }

  get className () {
    return this.element.dataset.classname
  }

  get parameterName () {
    return this.reviewSortValue ? 'sort_key' : 'sort_order'
  }

  initialize () {
    if (!('URLSearchParams' in window)) return

    const urlParams = new URLSearchParams(location.search)
    const currentSortKey = urlParams.get(this.parameterName)

    if (this.hasSelectTarget) {
      Array.from(this.selectTarget.options).forEach(option => {
        if (option.value === currentSortKey) {
          option.selected = true
        }
      })
      return
    }

    // タブ形式: 現在の並び順に対応するタブをアクティブにする。
    // sort_order未指定時や、URLに無効な並び順キーが残っている場合は先頭タブ（おすすめ順）をアクティブにする。
    const tabs = Array.from(this.element.querySelectorAll('[data-sort-value]'))
    const firstTabValue = tabs[0]?.dataset.sortValue
    const matched = tabs.some(tab => tab.dataset.sortValue === currentSortKey)
    const activeSortValue = matched ? currentSortKey : firstTabValue
    tabs.forEach(tab => {
      tab.dataset.active = tab.dataset.sortValue === activeSortValue ? '1' : '0'
    })
  }

  setUrl (e, sortId) {
    const currentUrl = new URL(window.location.href)
    const currentParams = new URLSearchParams(currentUrl.search)

    if (sortId && (this.reviewSortValue || sortId !== 'recommended')) {
      currentParams.set(this.parameterName, sortId)
    } else {
      currentParams.delete(this.parameterName)
    }

    currentParams.delete('page')

    currentUrl.search = currentParams.toString()
    const targetUrl = currentUrl.toString()

    return targetUrl
  }

  chengeSelect (e) {
    const sortId = e.target.value
    location.href = this.setUrl(e, sortId)
  }

  clickTab (e) {
    const sortId = e.currentTarget.dataset.sortValue
    location.href = this.setUrl(e, sortId)
  }
}
